import { useRef, useEffect } from 'react';
export function useIsMountedRef() {
    const isMounted = useRef(true);
    useEffect(() => () => {
        isMounted.current = false;
    }, []);
    return isMounted;
}
//# sourceMappingURL=useIsMountedRef.js.map